// extracted by mini-css-extract-plugin
export default {"tableWrap":"SubstitutionTable_tableWrap__DbZcT","tableHeader":"SubstitutionTable_tableHeader__ifjGz"};